module.exports = __webpack_public_path__ + "static/media/spinner.3f259006.gif";


//////////////////
// WEBPACK FOOTER
// ./src/components/common/Spinner/spinner.gif
// module id = 213
// module chunks = 0